<template>
  <v-drawer :direction="'right'" :width="'26%'">
    <!-- 底部箭头 -->
    <bar-card :bg="'border10'">
      <div class="topVideo">
        <c-title :item="topObj"></c-title>
        <div class="contentVideo">
          <iframe
            id="video"
            :src="form.url"
            frameborder="0"
            class="videobox"
          ></iframe>
        </div>
      </div>
      <div class="bottomVideo">
        <c-title :item="lsObj"></c-title>
        <div class="panel">
          <div class="tp_bot_no" v-if="!imgList || imgList.length === 0">
            <div class="notext">暂无图片</div>
          </div>

          <div class="tp_bot" v-if="imgList && imgList.length !== 0">
            <div class="img_top">
              <p class="sp_wz">
                {{ imgList.length > 0 ? imgList[status].date1 : "" }}
              </p>
              <el-image
                class="pic"
                :src="imgList.length > 0 ? imgList[status].path : ''"
                :preview-src-list="imgArr"
              ></el-image>
            </div>
            <div class="img_bot">
              <div class="swipers">
                <swiper :options="swiperOptionS" class="imgcases">
                  <swiper-slide
                    v-for="(it, index) in imgList"
                    :key="index"
                    class="swiper-slides"
                    @click="spClick(index)"
                  >
                    <img :src="it.path" @click="spClick(index)" />
                    <p
                      class="botTime"
                      :style="{ color: status === index ? '#0ff' : '' }"
                    >
                      {{ it.date }}
                    </p>
                  </swiper-slide>
                </swiper>
              </div>
              <div class="swiper-button-next"></div>
              <div class="swiper-button-prev"></div>
            </div>
          </div>
        </div>
      </div>
    </bar-card>
  </v-drawer>
</template>

<script>
import cTitle from "../components/title";
import {
  getScreenV2WlwNqImageByWlwCodeSameMonth,
  getScreenV2WlwVideoImageByWlwCodeSameMonth
} from "@/api/zhwl";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["graphic"])
  },
  components: {
    cTitle,
    Swiper,
    SwiperSlide
  },
  watch: {
    graphic() {
      const _d = Object.assign({}, this.graphic);
      _d.url = "./html/stream_rtmp_view.html?rtmp=" + _d.url;
      this.form = _d;
      this.topObj.name = this.graphic.name;
      this.getImg();
    }
  },
  data() {
    return {
      videoUrl: "",
      form: {},
      topObj: {
        src: require("images/zhwl/icon_sssj.png"),
        name: "",
        hasBtn: true,
        left: false
      },
      lsObj: {
        src: require("images/zhwl/icon_lssj.png"),
        name: "历史图片",
        hasBtn: false,
        left: false
      },
      swiperOptionS: {
        observer: true,
        observeParents: true,
        debugger: true,
        autoplayDisableOnInteraction: false,
        slidesPerView: "auto", // 设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        centeredSlides: true, // <span style="color:rgb(68,68,68);font-family:'microsoft yahei';font-size:13px;">设定为true时，活动块会居中，而不是默认状态下的居左。</span>
        prevButton: ".swiper-button-prev", // 上一张
        nextButton: ".swiper-button-next" // 下一张
      },
      imgList: [],
      imgArr: [],
      status: 0,
      times: "2020-08-30 13:34",
      src: require("images/zhwl/pic_a.png"),
      srcLists: []
    };
  },
  mounted() {
    const _d = Object.assign({}, this.graphic);
    _d.url = "./html/stream_rtmp_view.html?rtmp=" + _d.url;
    this.form = _d;
    this.topObj.name = this.graphic.name;
    this.getImg();
  },
  methods: {
    getImg() {
      this.imgList = [];
      var interMapping = {
        video: getScreenV2WlwVideoImageByWlwCodeSameMonth,
        nq: getScreenV2WlwNqImageByWlwCodeSameMonth
      };
      interMapping[this.form.type] &&
        interMapping[this.form.type]({
          wlwCode: this.graphic.code,
          day: 5
        }).then(res => {
          if (res.code === 200 && res.data.length > 0) {
            this.imgList = res.data;
            this.imgList.map(it => {
              it.path = this.$config.imgIp + it.path;
              this.imgArr.push(it.path);
            });
          }
        });
    },
    spClick(index) {
      if (this.imgList.length > 0) {
        this.status = index;
      }
    }
  }
};
</script>

<style scoped>
.videoModel {
  height: calc(100% - 136px);
  z-index: 99999;
  position: fixed;
  right: 0;
  width: 26%;
  top: 112px;
  padding: 12px;
}

.tp_bot_no {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notext {
  color: #80e4fb;
  font-size: 22px;
  border: solid 1px #80e4fb;
  border-radius: 6px;
  padding: 12px;
}

.topArrow::after {
  content: "";
  border-top: solid 4px #80e4fb;
  border-left: solid 4px #80e4fb;
  padding: 0.05208rem;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.topArrow::before {
  content: "";
  border-top: solid 4px #80e4fb;
  border-right: solid 4px #80e4fb;
  padding: 0.05208rem;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}

.buttomArrow::after {
  content: "";
  border-bottom: solid 4px #80e4fb;
  border-left: solid 4px #80e4fb;
  padding: 0.05208rem;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
}
.buttomArrow::before {
  content: "";
  border-bottom: solid 4px #80e4fb;
  border-right: solid 4px #80e4fb;
  padding: 0.05208rem;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 1;
}
</style>

<style lang="stylus" scoped>
.topVideo
  height 52%

.contentVideo
  height calc(100% - 31px)
  width calc(100% - 30px)
  margin 0 15px

.videobox
  width 100%
  height calc(100% - 15px)
  margin-top 5px

.bottomVideo
  height 48%

.panel
  height calc(100% - 0.265rem)
  width calc(100% - 30px)
  margin 0 15px

  .el-carousel
    height 100%

  >>>.el-carousel__container
    height 100%

  >>>.el-carousel__arrow--left
    left 0

  >>>.el-carousel__arrow--right
    right 0

  .flex
    position absolute
    top 50%
    transform translate(0, -50%)
    width 100%

    .img-box
      width 32%
      margin 0 .5%
      position relative

    .time
      position absolute
      right 5px
      bottom 5px
      color $textColor

.swipers
  width 100%
  overflow hidden
  height 100%

.imgcases
  width 33.38%
  overflow initial
  margin 0
  height 100%

.imgcases img
  border 1px solid #0ff
  cursor pointer
  width 88%
  height calc(100% - 11px)
  margin 0 6%

.swiper-slides
  cursor pointer
  display flex
  align-content center
  justify-content center
  flex-direction column
  position relative

.tp_bot
  margin-top 10px
  height calc(100% - 10px)

.img_top
  height calc(60% - 10px)
  position relative
  justify-content center
  border 1px solid #00ffff
  margin 0 4%
  display flex
  align-items center
  margin-bottom 10px

.img_top img
  height 100%

.pic
  width 100%
  height 100%

.img_bot
  height 40%
  width 96%
  position relative
  padding 0 2%

.botTime
  width 88%
  margin 0 6%
  margin-top 10px
  color #fff
  border-radius 15px
  position absolute
  left 5px
  bottom 6px

.swiper-button-next, .swiper-container-rtl .swiper-button-prev
  right -5px
  left auto

.swiper-button-prev, .swiper-container-rtl .swiper-button-next
  left -3px
  right auto

.swiper-button-prev, .swiper-button-next
  position absolute
  top 65%
  width 15px
  height 20px
  margin-top -22px
  z-index 10
  cursor pointer
  background-size 18px 20px
  background-position center

.sp_wz
  position absolute
  left 0px
  top 0px
  border 1px #0ff solid
  background #021226
  z-index 999
  padding 5px
  margin 0
  color #0ff

.pic
  >>>.el-image-viewer__close
    color #fff
    top 110px

    @media (max-width 1366px)
      top 76px
</style>
